'use client';

import Link from 'next/link';
import type { ComponentProps } from 'react';

/**
 * NavLink — a single wrapper over next/link for persistent chrome (sidebar nav,
 * header badges) that stays mounted across the whole session.
 *
 * Why: the default <Link> prefetches its target's RSC payload when it's in the
 * viewport AND re-prefetches on re-render. In always-mounted chrome that re-renders
 * during long-lived flows (generation ticks, SSE balance updates) this turned into
 * a storm of `?_rsc=…` requests for every nav route. These destinations are clicked
 * rarely, so we default `prefetch={false}` and fetch on click instead (~one route
 * load, no perceptible delay). Flip the policy here, in ONE place, if ever needed.
 *
 * Fully transparent otherwise: every prop (className, onClick, data-testid, style,
 * children, …) passes straight through, so styling is unchanged.
 */
export function NavLink({ prefetch = false, ...props }: ComponentProps<typeof Link>) {
  return <Link prefetch={prefetch} {...props} />;
}
